<template>
  <div v-if="historyItems.length">
    <h3>Will History ({{ historyItems.length }})</h3>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Version</th>
            <th>Uploaded</th>
            <th>Validation</th>
            <th>Validated On</th>
            <th>Vaulted</th>
            <th>Vaulted On</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in historyItems"
            :key="item.id"
            class="clickable-row"
            @click="navigateToWill(item)"
          >
            <td>{{ item.willVersion }}</td>
            <td>
              <span v-if="item.uploadedAt">
                {{ item.uploadedAt }}
              </span>
              <span v-else class="grey--text">-</span>
            </td>
            <td>
              <v-chip
                small
                :color="item.statusDetails.color"
                text-color="white"
              >
                {{ item.statusDetails.status }}
              </v-chip>
              <v-icon
                v-if="item.comments"
                color="#333"
                class="ml-1 comment-icon"
                @click.stop="openCommentsDialog(item)"
              >
                {{ icons.mdiInformationOutline }}
              </v-icon>
            </td>
            <td>{{ item.validatedOn }}</td>
            <td>
              <v-icon v-if="item.vaulted" color="green" small>
                {{ icons.mdiCheckCircleOutline }}
              </v-icon>
              <span v-else class="grey--text">-</span>
            </td>
            <td>{{ item.vaultedOn }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="commentsDialog" max-width="500">
      <v-card>
        <v-card-title>
          Validation Comments
          <v-spacer />
          <v-icon @click="commentsDialog = false">
            {{ icons.mdiClose }}
          </v-icon>
        </v-card-title>
        <v-card-text v-if="selectedItem">
          <p class="mt-2">{{ selectedItem.comments }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <p v-else class="grey--text">No will history available</p>
</template>

<script>
  import { verificationStatus } from '../../../constants/js/will-verification';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import {
    CREATE_UPLOADED_WILL_PRESIGNED_URL_MUTATION,
    CREATE_WILL_VERSION_PRESIGNED_URL_MUTATION,
  } from '../../../constants/graphql/will-verifications';

  export default {
    name: 'WillHistory',
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        commentsDialog: false,
        selectedItem: null,
      };
    },
    computed: {
      historyItems() {
        if (!this.testator?.willVersions) return [];

        const items = [];

        const sortedVersions = [...this.testator.willVersions].sort(
          (a, b) => b.version - a.version
        );

        sortedVersions.forEach(willVersion => {
          if (willVersion.uploadedWills?.length) {
            const sortedUploads = [...willVersion.uploadedWills].sort(
              (a, b) => b.version - a.version
            );

            sortedUploads.forEach(upload => {
              const isVaulted =
                !!willVersion.dateStored && upload.status === 'VALID';
              items.push({
                id: `${willVersion.id}-${upload.id}`,
                uploadId: upload.id,
                willVersionId: willVersion.id,
                willVersion: willVersion.version,
                uploadedAt: this.formatDate(upload.createdAt),
                comments: upload.comments,
                statusDetails: verificationStatus(upload.status, this.icons),
                validatedOn:
                  willVersion.status !== 'UNVERIFIED'
                    ? this.formatDate(willVersion.updatedAt)
                    : '',
                vaulted: isVaulted,
                vaultedOn: isVaulted
                  ? this.formatDate(willVersion.dateStored)
                  : '',
              });
            });
          } else {
            items.push({
              id: willVersion.id,
              uploadId: null,
              willVersionId: willVersion.id,
              willVersion: willVersion.version,
              uploadedAt: null,
              comments: null,
              statusDetails: verificationStatus(willVersion.status, this.icons),
              validatedOn:
                willVersion.status !== 'UNVERIFIED'
                  ? this.formatDate(willVersion.updatedAt)
                  : '',
              vaulted: !!willVersion.dateStored,
              vaultedOn: this.formatDate(willVersion.dateStored),
            });
          }
        });

        return items;
      },
    },
    methods: {
      openCommentsDialog(item) {
        this.selectedItem = item;
        this.commentsDialog = true;
      },
      navigateToWill(item) {
        var newTab = window.open('', '_blank');
        const mutation = item.uploadId
          ? CREATE_UPLOADED_WILL_PRESIGNED_URL_MUTATION
          : CREATE_WILL_VERSION_PRESIGNED_URL_MUTATION;
        const id = item.uploadId || item.willVersionId;
        const responseKey = item.uploadId
          ? 'createUploadedWillPresignedUrl'
          : 'createWillVersionPresignedUrl';

        this.$apollo
          .mutate({
            mutation,
            variables: { id },
          })
          .then(response => {
            newTab.location.href = response.data[responseKey];
          })
          .catch(error => {
            newTab.close();
            this.displayError();
            throw error;
          });
      },
      formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
      },
    },
  };
</script>

<style lang="scss" scoped>
  h3 {
    margin-bottom: 12px;
  }

  .v-data-table {
    max-height: 400px;
    overflow-y: auto;
  }

  .comment-icon {
    &::after {
      display: none;
    }

    &:focus::after {
      display: none;
    }
  }

  .clickable-row {
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
</style>
